'use client';

import { EpisodeType } from '@elsevier-health/osmosis-shared/types/podcast';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { hoverBg100 } from '@osmosis/tailwind-ui/styles/background';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PODCAST_URL } from '../../constants/urls';
import Link from 'next/link';
import PublishedDate from './PublishedDate';

type Props = {
  episode: EpisodeType;
};

/**
 * Podcast episode row.
 */
const PodcastEpisodeRow = ({ episode }: Props) => {
  return (
    <Link href={`${PODCAST_URL}/${episode.slug}`}>
      <Box
        cn={`rounded-lg p-8 flex sm:gap-4 gap-8 sm:flex-row flex-col cursor-pointer ${hoverBg100}`}
      >
        <Box cn="flex flex-col gap-8">
          <P cn="uppercase opacity-75">
            <FormattedMessage
              id="podcast-episode-row.episode_number"
              defaultMessage="Episode {number}"
              values={{ number: episode.number }}
            />
          </P>
          <H2>{episode.title}</H2>
          <PublishedDate date={episode.published_at} />
          <Box>
            <P cn="line-clamp-2 text-ellipsis">{episode.description}</P>
          </Box>
        </Box>

        <Box cn="flex items-center">
          <Button rounded data-testid={`episode-${episode.number}-listen-btn`}>
            <FormattedMessage id="episode-row.listen" defaultMessage="Listen" />
          </Button>
        </Box>
      </Box>
    </Link>
  );
};

export default PodcastEpisodeRow;
